export const PROJETS_INITIAL_FORM = {
  titre: "",
  description: "",
  image_projet_url: "",
  page_detail_url: "",
  is_active: true,
};

export const PROJETS_STATUS_OPTIONS = [
  {
    value: "all",
    label: "Tous",
    description: "Afficher tous les projets.",
  },
  {
    value: "active",
    label: "Publiés",
    description: "Visibles sur le site public.",
  },
  {
    value: "inactive",
    label: "Brouillons",
    description: "Masqués du site public.",
  },
];

export const PROJETS_LIMIT_OPTIONS = [12, 24, 48, 96];

export const PROJETS_FORM_HELPERS = [
  "Utilisez un titre clair pour identifier rapidement le projet.",
  "Ajoutez une image pour rendre le projet plus visible sur le site.",
  "Le lien détail peut pointer vers une page interne ou un site externe.",
];

export const PROJETS_MEDIA_CATEGORY_DEFAULT = "projets";